// extracted by mini-css-extract-plugin
export var numpadContainer = "_oe-1";
export var phoneButton = "_oe-0";